module.exports = __webpack_public_path__ + "static/img/65034C_1_C_20201019_LC.d0c6035.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/65034C_1_C_20201019_LC.png
// module id = g2fi
// module chunks = 0